import * as THREE from 'three';

export function Plane(
    width: number,
    height: number,
    radius: number,
    color: number
): THREE.Mesh {
    const shape = new THREE.Shape();
    let material;
    if (color === 0xffffff) {
        material = new THREE.MeshBasicMaterial({ color: color, side: THREE.DoubleSide });
    } else {
        material = new THREE.MeshBasicMaterial({ color: color, side: THREE.DoubleSide,transparent: true, opacity: .1});
    }

    // Décalage pour centrer (x, y)
    const offsetX: number = -width / 2;
    const offsetY: number = -height / 2;

    shape.moveTo(offsetX + radius, offsetY);
    shape.lineTo(offsetX + width - radius, offsetY);
    shape.quadraticCurveTo(offsetX + width, offsetY, offsetX + width, offsetY + radius);
    shape.lineTo(offsetX + width, offsetY + height - radius);
    shape.quadraticCurveTo(offsetX + width, offsetY + height, offsetX + width - radius, offsetY + height);
    shape.lineTo(offsetX + radius, offsetY + height);
    shape.quadraticCurveTo(offsetX, offsetY + height, offsetX, offsetY + height - radius);
    shape.lineTo(offsetX, offsetY + radius);
    shape.quadraticCurveTo(offsetX, offsetY, offsetX + radius, offsetY);

    const geometry = new THREE.ShapeGeometry(shape);
    const plane = new THREE.Mesh(geometry, material);

    return plane;
}